const filterTrigger = document.getElementById('filter-trigger')
const filterTriggerMobile = document.getElementById('filter-trigger-mobile')
const animationWrap = document.querySelector('.animation-wrap') as HTMLElement
const detailedFilter = document.getElementById('detailed-filter') as HTMLElement
const body = document.querySelector('body')

function resize() {
  animationWrap.style.transform =
    'translateY(-' + detailedFilter.clientHeight + 'px)'
}

if (filterTrigger) {
  window.onresize = resize
  filterTrigger.addEventListener('click', () => {
    filterTrigger.classList.toggle('active')
    if (animationWrap.classList.contains('show')) {
      animationWrap.style.transform =
        'translateY(-' + detailedFilter.clientHeight + 'px)'
      animationWrap.classList.remove('show')
    } else {
      animationWrap.style.transform = 'translateY(0px)'
      animationWrap.classList.add('show')
    }
  })
}

if (filterTriggerMobile) {
  filterTriggerMobile.addEventListener('click', () => {
    body!.classList.toggle('overflow-hidden')
    filterTriggerMobile.classList.toggle('active')
    if (animationWrap.classList.contains('show')) {
      detailedFilter.style.transform = 'translateX(-100%)'
      animationWrap.classList.remove('show')
    } else {
      detailedFilter.style.transform = 'translateX(0px)'
      animationWrap.classList.add('show')
    }
  })
}
